import { useBienContext } from '../BienContext'

import { EyeIcon } from '@heroicons/react/24/solid'
import { formatPrice, formatDate } from '@/utils/formatters'
import { Input, Textarea } from '@/components/ui'
import DetailTemplate from '@/components/DetailTemplate'
import EditButtons from '../EditButtons'
import Form from './Form'

export default () => {
  const { bien, 
    updatedSections, markSectionAsUpdated, 
    isPendingAction, closeModalCallback
  } = useBienContext()

  const SECTION_ID = 'copropriete'
  const SECTION_TITLE = "Copropriété"

  const modalContent = <Form title={SECTION_TITLE} />
  
  const InputDisplayFile = ({item, label, name, title}) => {

    const file = item ? item[name] : null

    const handleClick = (e) => {
      e.preventDefault()
      e.stopPropagation()
      window.open(file.url , '_blank')
    }

    return (
      <div className="flex items-center justify-between">
        <Input.Display label={label} 
          className="flex items-center mb-2 w-full max-w-9/10"
          labelClassName="" 
          valueClassName="overflow-hidden max-w-4/5 text-nowrap"
        >
          { file?.filename ?
              file?.url ? 
                <button title={`Voir ${title}`} className="flex cursor-pointer" onClick={handleClick}>
                  <span>{file.filename}</span>
                </button> :
                <span>{file.filename}</span> :
                null
          }
        </Input.Display>
        <div className="flex mb-2 ml-2 mr-4">
          { !!file?.url && (
            <button 
              onClick={handleClick}
              className="btn btn-xs btn-ghost btn-square p-1 hover:bg-primary-400"
              title={`Voir ${title}`} aria-label={`Voir ${title}`}
            >
              <EyeIcon/>
            </button>
          )}
        </div>
      </div>
    )
  }

  const editButton = <EditButtons
    bienId={bien.id}
    isArchived={!!bien.archived_at}
    isPendingAction={isPendingAction}
    title="Modifier la section Copropriété"
  /> 

  return(
    <DetailTemplate
      title={SECTION_TITLE}
      sectionId={SECTION_ID}
      bodyProps={{columns: 3}}
      updatedSections={updatedSections}
      loading={false}
      isPendingAction={isPendingAction}
      editButton={editButton}
      modalContent={modalContent}
      onUpdateSuccess={markSectionAsUpdated}
      onCloseModalCallback={closeModalCallback}
    >
      <div className="space-y-4">
        <Input.Display label="Numéro de lot" value={bien.copropriete_numero_lot} valueClassName="uppercase" />
        <Input.Display label="Montant des charges" value={formatPrice(bien.copropriete_montant_charges)} />
        <Input.Display label="Détails des charges" value={bien.copropriete_detail_charges} valueClassName="uppercase" />
        <Input.Display label="Date de la dernière AG" value={formatDate(bien.copropriete_date_derniere_ag)}/>
        <InputDisplayFile label="Règlement copro." title="le règlement de la copropriété" 
          item={bien} name="reglement_copropriete_file"
        />
      </div>
      <div className="space-y-4">
        <Input.Display label="Nom du syndic" value={bien.copropriete_syndic_nom} valueClassName="uppercase" />
        <Textarea.Display 
          label="Accès compte Syndic"
          value={bien.copropriete_syndic_compte}
          className='flex flex-col items-start'
        />
      </div>
      <div className='flex space-x-4'>
        <Textarea.Display 
          label="Divers (gardien, interphone, espaces verts, ...)"
          value={bien.copropriete_divers}
          className='flex flex-col items-start'
        />
      </div>

    </DetailTemplate>
  )
}